import { useCallback } from 'react'
import { useSegmentAnalytics } from '../components/Provider'

type TrackFlowPageActionParams = {
  questionName: string
  questionValue: string | boolean | number | string[] | undefined | null
}

export const useTrackFlowPageAction = () => {
  const analytics = useSegmentAnalytics()

  return useCallback(
    (params: TrackFlowPageActionParams) => {
      // Transform question_value: replace underscores with dashes
      let transformedValue = params.questionValue
      if (typeof params.questionValue === 'string') {
        transformedValue = params.questionValue.replace(/_/g, '-')
      } else if (Array.isArray(params.questionValue)) {
        // Convert array of strings to comma-separated string with underscores replaced, sorted alphabetically
        transformedValue = params.questionValue
          .map((item) => item.replace(/_/g, '-'))
          .sort()
          .join(',')
      }

      analytics.track('Page Action', {
        question_name: params.questionName,
        question_value: transformedValue,
      })
    },
    [analytics]
  )
}
